import React, { Component, createRef } from "react";
import Moment from "moment";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Grid,
  Divider,
  Box,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import DOMPurify from "dompurify";

Moment.locale("en");

class Notifications extends Component {
  state = {
    notifications: this.props.notifications,
    node: createRef(),
  };

  handleClick = (e) => {
    if (this.state.node.current && this.state.node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    this.props.setHidden();
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
  }

  render() {
    return (
      <Box
        ref={this.state.node}
        sx={{
          border: "1px solid #ddd",
          borderRadius: 1,
          bgcolor: "background.paper",
        }}
      >
        <List disablePadding id="notificationList">
          <Box sx={{ p: 1 }}>
            <Typography variant="caption">
              {this.state.notifications.Count ? (
                <React.Fragment>
                  {this.state.notifications.Items.map((i, index) => {
                    const isInternalLink = i.link.charAt(0) === "/";
                    const isEmptyLink = i.link === "empty";
                    const isUnread = !i.isRead;

                    const itemContent = (
                      <ListItemText
                        primary={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(i.message),
                            }}
                          />
                        }
                        secondary={Moment.unix(i.createdAt).format(
                          "YYYY/MM/DD hh:mm a"
                        )}
                        primaryTypographyProps={{ fontSize: "0.875rem" }}
                        secondaryTypographyProps={{ fontSize: "0.75rem" }}
                      />
                    );

                    const commonProps = {
                      onClick: () => this.props.locallyRead(index),
                      sx: {
                        bgcolor: isUnread ? "action.selected" : "transparent",
                        "&:hover": {
                          bgcolor: isUnread ? "action.hover" : "rgba(0, 0, 0, 0.04)",
                        },
                      },
                    };

                    if (isInternalLink) {
                      return (
                        <ListItemButton
                          key={index}
                          component={RouterLink}
                          to={i.link}
                          {...commonProps}
                        >
                          {itemContent}
                        </ListItemButton>
                      );
                    }

                    if (isEmptyLink) {
                      return (
                        <ListItem key={index} {...commonProps}>
                          {itemContent}
                        </ListItem>
                      );
                    }

                    // External link
                    return (
                      <ListItemButton
                        key={index}
                        component="a"
                        href={i.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        {...commonProps}
                      >
                        {itemContent}
                      </ListItemButton>
                    );
                  })}
                </React.Fragment>
              ) : (
                <ListItem>
                  <ListItemText primary="No new notifications" />
                </ListItem>
              )}
            </Typography>
          </Box>
          {this.state.notifications.Count > 0 && (
            <React.Fragment>
              <Divider />
              <ListItemButton
                onClick={this.props.readAll}
                sx={{ textAlign: "center" }}
              >
                <ListItemText
                  primary="Mark all as read"
                  primaryTypographyProps={{
                    fontSize: "0.875rem",
                    color: "primary.main",
                  }}
                />
              </ListItemButton>
            </React.Fragment>
          )}
        </List>
      </Box>
    );
  }
}

export default Notifications;
